import React, { useCallback, useRef, useEffect } from 'react';
import { smoothScrollIntoView } from '@cian/valuation-utils-component';

import { ETrackGoToApplicationFormLabel, trackGoToApplicationForm } from '../PageContainer/tracking';
import { HelpSearchRealtor } from '../../components/HelpSearchRealtor';
import { SCROLL_HASH } from './constants/hash';

export const HelpSearchRealtorContainer: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);

  /** Страница проскроллится к этому блоку, если в url присутствует нужный хэш параметр */
  useEffect(() => {
    const node = ref.current;
    if (node && location.hash.includes(SCROLL_HASH)) {
      smoothScrollIntoView(node, 32);
    }
  }, []);

  const onClickGoToAppFormSearch = useCallback(
    () => trackGoToApplicationForm(ETrackGoToApplicationFormLabel.Search),
    [],
  );

  return <HelpSearchRealtor ref={ref} onClickGoToApplicationForm={onClickGoToAppFormSearch} />;
};

HelpSearchRealtorContainer.displayName = 'HelpSearchRealtorContainer';
